module.exports = __webpack_public_path__ + "static/img/img_password_pic.20faf37.png";


//////////////////
// WEBPACK FOOTER
// ./static/login/img_password_pic.png
// module id = 5zOu
// module chunks = 83